import React from "react";
import { AlertOctagon } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ConfirmPH ErrorBoundary caught:", error, info);
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center px-4 bg-[#FAFAFA]"
           data-testid="error-fallback">
        <div className="max-w-md text-center">
          <AlertOctagon className="w-12 h-12 mx-auto text-rose-500" />
          <h1 className="font-display text-2xl font-bold mt-4">Something went wrong</h1>
          <p className="text-slate-600 mt-2">
            We hit an unexpected error. Please try again, refresh the page, or contact support if it keeps happening.
          </p>
          <div className="mt-6 flex flex-wrap gap-2 justify-center">
            <button
              onClick={() => window.location.reload()}
              data-testid="error-reload"
              className="px-4 py-2 rounded-lg btn-brand font-medium text-sm">
              Reload
            </button>
            <a href="/support" data-testid="error-support"
                className="px-4 py-2 rounded-lg border border-slate-300 hover:bg-slate-50 text-sm">
              Contact support
            </a>
          </div>
        </div>
      </div>
    );
  }
}
